import ReactDOM from "react-dom";

const CreatePortalCard = ({ children, id, open }) => {
  if (!open) return children;
  return ReactDOM.createPortal(
    <div>{children}</div>,
    document.getElementById(id) // Specify the container element
  );
};

export default CreatePortalCard;
